import * as types from 'constants/usersActionTypes';

const initialState = {
  loading: false,
  data: [],
  error: null
};

export default (state = { ...initialState }, action = {}) => {
  switch (action.type) {
    case types.GET_USERS_LOADING: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case types.GET_USERS_SUCCESS: {
      const { response } = action;
      return {
        ...state,
        loading: false,
        error: null,
        list: response
      };
    }
    case types.LOCK_USER_LOADING: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case types.LOCK_USER_SUCCESS: {
      const { response } = action;
      console.log('En reducer users { usuarios } = action: ', response);
      return {
        ...state,
        data: response,
        loading: false,
        error: null
      };
    }
    case types.GET_USERS_NOT_LOADING: {
      return {
        ...state,
        loading: false,
        error: null
      };
    }
    default:
      return state;
  }
};
